<template>
  <div class="yuliang" ref="yuliang">
    <div class="select">
      <!-- 类别 -->
      <div class="storageType" >
        <span class="desc">选择时间：</span>
        <el-date-picker v-model="selecttime1" :picker-options="Global.pickerOptionsStart(selecttime2)" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择开始时间" default-time="08:00">
        </el-date-picker>
        <span class="desc">至</span>
        <el-date-picker v-model="selecttime2" :picker-options="Global.pickerOptionsEnd(selecttime1)" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择结束时间"  default-time="08:00">
        </el-date-picker>
      </div>
      <div>
        <span id="select" @click="tabledata">查询</span>
      </div>
      <div class="export">
          <span @click="exportdata" id="export"><span class="export-icon"></span>导出</span>
      </div>
    </div>
    <div class="raintable">
      <el-table v-loading="loading" :row-class-name="tableRowClassName" :data="tdata" :height="height" border style="width: 100%;" :default-sort ="{prop:'overflowWarningWater',order:'descending'}">
        <el-table-column prop="tm" align="center" header-align="center" label="时间" min-width="150" sortable>
        </el-table-column>
        <el-table-column  prop="stnm" align="left" header-align="left" label="水库名称" min-width="120">
        </el-table-column>
        <el-table-column  prop="z" align="left" header-align="left" label="水位(m)" min-width="120">
        </el-table-column>
      </el-table>
    </div>
    <div style="float:left">
      <pager
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
        :pageIndex="query.pageIndex"
        :pageSize="query.pageSize"
        :total="query.total"
      ></pager>
    </div>
  </div>
</template>
<script>
import riverwatersituationTypes from '@/store/types/riverwatersituation'
import { Pager } from '@/components'
import timer from '@/utils/timer'
export default {
  components: {
    Pager
  },
  name: 'MonitoringCenter',
  data () {
    return {
      loading: true,
      timerFun: '',
      height: 10,
      aDDVCD: '',
      stationName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      query: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      },
      towns: [],
      checkarr: [],
      dialogVisible: false,
      sTID: '',
      time: '',
      sID: 22,
      storageType: '',
      selecttime1: '',
      selecttime2: ''
    }
  },
  computed: {
  },
  methods: {
    // 列排序
    sortChange1 (a, b) {
      return a.waterAtEight - b.waterAtEight
    },
    sortChange2 (a, b) {
      return a.water - b.water
    },
    sortChange3 (a, b) {
      return a.warningWater - b.warningWater
    },
    sortChange4 (a, b) {
      return a.overflowWarningWater - b.overflowWarningWater
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        console.log(row.overflowWarningWater)
        return 'warning-row'
      }
      return ''
    },
    tabledata () {
      this.loading = true
      this.$store.dispatch(riverwatersituationTypes.getReservoirIntervalWaterStatistics, {
        sID: this.sID,
        BeginDate: this.selecttime1,
        EndDate: this.selecttime2,
        PageIndex: this.query.pageIndex,
        PageSize: this.query.pageSize
      }).then(data => {
        this.loading = false
        this.tdata = data.results
        this.query.total = data.total
        // this.dataSort('overflowWarningWater', this.tdata)
      })
    },
    setListCheck: function (idx, adcd) {
      this.loading = true
      this.all = false
      var check = this.towns[idx].check
      this.towns[idx].check = !check
      let checknum = this.thecheck()
      this.addcheckarr(adcd, this.towns[idx].check)
      // console.log(adcd, this.towns[idx].check)
      // 拼接截取
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.aDDVCD = ''
        this.checkarr.forEach((item) => {
          this.aDDVCD += item.substring(0, 9) + ','
        })
        this.aDDVCD = this.aDDVCD.substring(0, this.aDDVCD.length - 1)
        this.tabledata()
      }
      // 0或全选 变为全部
      if (checknum === this.adcdtotal || checknum === 0) {
        this.setAllCheck()
      }
    },
    addcheckarr: function (adcd, state) {
      if (state) {
        this.checkarr.push(adcd)
      } else {
        this.deletecheckarr(adcd)
      }
    },
    deletecheckarr: function (adcd) {
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.checkarr.forEach((item, index) => {
          if (item === adcd) {
            this.checkarr.splice(index, 1)
          }
        })
      }
    },
    setAllCheck: function () {
      this.all = true
      this.checkarr = []
      this.aDDVCD = ''
      this.towns.forEach((item) => {
        item.check = false
      })
      this.tabledata()
    },
    thecheck: function () {
      let num = 0
      this.towns.forEach((item) => {
        if (item.check) {
          num++
        }
      })
      return num
    },
    // 数据排序
    dataSort (type, sortData) {
      this.sortType = type
      sortData.sort(this.compare(type))
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val2 - val1
      }
    },
    exportdata () {
      this.$store.dispatch(riverwatersituationTypes.exportReservoirIntervalWaterStatistics, {
        sID: this.sID,
        BeginDate: this.selecttime1,
        EndDate: this.selecttime2
      }).then(data => {
        let blob = new Blob([data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '水库时段水位统计.xls'
        link.click()
        link.remove()
      })
    },
    onSizeChange (size) {
      this.query.pageSize = size
      this.loading = true
      this.tabledata()
      // this.loadTableData()
    },
    onCurrentChange (page) {
      this.query.pageIndex = page
      this.loading = true
      this.tabledata()
      // this.loadTableData()
    },
    getTime () {
      let date = new Date()
      let preDate = new Date(date.getTime() - 24 * 60 * 60 * 1000)
      let hour = date.getHours()
      if (hour < 8) { // 当前时间在8:00之前
        this.selecttime1 = this.$moment(preDate).format('YYYY-MM-DD 08:00')
        // this.selecttime1 = new Date(year, month - 1, day - 1, 8, 0)
      } else {
        this.selecttime1 = this.$moment(date).format('YYYY-MM-DD 08:00')
        // this.selecttime1 = new Date(year, month - 1, day, 8, 0)
      }
      this.selecttime2 = this.$moment(date).format('YYYY-MM-DD HH:00')
      // this.selecttime2 = new Date(year, month - 1, day, hour, 0)
    }
  },
  mounted () {
    this.getTime()
    this.tabledata()
    this.timerFun = setInterval(() => {
      this.getTime()
      this.tabledata()
    }, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 60
    })
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped></style>
<style lang="less" scoped>
.monitor{
  .content{
    .yuliang{
      .select{
        display: flex;
        position: relative;
        .el-input{
          width: 165px;
        }
        .export {
          position: absolute;
          right: 0;
        }
        div.storageType{
          display: flex;
          position: relative;
          bottom: 8px;
          div{
            width:220px;
          }
        }
      }
    }
  }
}
// 样式穿透
.content /deep/ .yuliang .raintable .el-table .warning-row{
  background:#f3f364 !important;
}
#station{
  width: 100%;
  height: 400px;
}
.block{
  position: absolute;
  width: 95%;
  top: 15px;
  left: 0;
  text-align: center;
}
.chartshuiwei{
    text-align: center;
    width: 100%;
    // text-align: center;
  }
</style>
